import { useEffect, useMemo, useState } from "react";
import { fetchMuscleContributions } from "../../services/api";
import {
  builderVolumeEntries,
  computePlannedMuscleVolume,
  toMuscleVolumeItems,
} from "./plannedMuscleVolume";

// One request per session: every builder edit recomputes locally from this map.
let catalogPromise = null;

function loadCatalog() {
  if (!catalogPromise) {
    catalogPromise = Promise.resolve()
      .then(() => fetchMuscleContributions())
      .then((response) => {
        if (!response || typeof response.items !== "object" || response.items === null) {
          throw new Error("Invalid muscle contribution response");
        }
        return response.items;
      })
      .catch((error) => {
        catalogPromise = null;
        throw error;
      });
  }
  return catalogPromise;
}

export function resetMuscleContributionCatalogForTests() {
  catalogPromise = null;
}

export function useMuscleContributionCatalog() {
  const [state, setState] = useState({ status: "loading", catalog: null });

  useEffect(() => {
    let active = true;
    loadCatalog().then(
      (catalog) => active && setState({ status: "ready", catalog }),
      () => active && setState({ status: "error", catalog: null })
    );
    return () => {
      active = false;
    };
  }, []);

  return state;
}

// workouts: builder / viewer workouts (memoized by the caller). Returns
// MuscleDistribution items, the unclassified physical sets and the load status.
export function usePlannedMuscleVolume(workouts) {
  const { status, catalog } = useMuscleContributionCatalog();

  return useMemo(() => {
    if (status !== "ready") return { status, items: [], unclassifiedSets: 0 };
    const volume = computePlannedMuscleVolume(builderVolumeEntries(workouts), catalog);
    return { status, items: toMuscleVolumeItems(volume), unclassifiedSets: volume.unclassifiedSets };
  }, [status, catalog, workouts]);
}
